import composeRequest, { authHeaders, hostHeaders, method, query, urlTagged } from 'api/helpers';

export function searchRequest({ ampUrl, host, params, profileId, sessionId }) {
  return composeRequest(
    method('get'),
    urlTagged`${{ ampUrl }}/api/v3/search/all`,
    query({ ...params }),
    authHeaders(profileId, sessionId),
    hostHeaders(host)
  )();
}
